let _loaded = false;
let _promise = null;

function hasGoogleMaps() {
    return typeof window !== 'undefined' && !!window.google?.maps;
}

export function loadGoogleMaps() {
    if (_loaded) return Promise.resolve();
    if (_promise) return _promise;

    _promise = new Promise((resolve, reject) => {
        // Google Maps is already loaded by the layout script tag
        if (hasGoogleMaps()) {
            _loaded = true;
            resolve();
            return;
        }

        // Wait for it to load (layout includes the script)
        const interval = setInterval(() => {
            if (hasGoogleMaps()) {
                _loaded = true;
                clearInterval(interval);
                resolve();
            }
        }, 100);

        setTimeout(() => {
            clearInterval(interval);
            reject(new Error('Google Maps failed to load'));
        }, 15000);
    });

    return _promise;
}
